export function openAuthModal(defaultView = 'signup') {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent('open-auth', { detail: defaultView === 'login' ? 'login' : 'signup' }));
}

export function requireAuthAction(isAuthenticated, action, defaultView = 'signup') {
  if (isAuthenticated) {
    action?.();
    return true;
  }
  openAuthModal(defaultView);
  return false;
}